import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import {
    X_SMALL_TEXT_PX,
    SMALL_TEXT_PX,
    DARK_NAVY_FONT_COLOR,
    FONT_FAMILY_DEMI,
    FONT_FAMILY_REGULAR,
    TITLE_FONT_COLOR
} from '../../../styles/fonts/MCFontConstants';

export const FilterOptionSelectTemplate = styled.div`
    width: 100%;
    position: relative;
    margin-top: 5px;
    ${media.smalDevice`
        width: 90%;
        margin-top: 15px;
    `}
    ${media.mobileDevice`
        padding: 0;
        width:100%;
    `}
`;

export const FilterOptionSelect = styled.div`
    position: relative;
    padding: 10px 0 10px 0;
    width: ${(props) => (props.widthTemplate ? '100%' : props.fimDashboardFilterResultsPanel ? '85%' : ' ')};
    ${media.mobileDevice`
        padding: 0;
        width: ${(props) => (props.mobWidthTemplate ? 'auto' : ' ')};
    `}
`;

export const FilterContainer = styled.div`
    flex-direction: ${(props) =>
        props.flexDirection ? props.flexDirection : ''};
    background-color: (props.backgroundColor ? props.backgroundColor : '#ffffff')};
    display: flex;
    font-family: ${FONT_FAMILY_REGULAR};
    font-size: ${SMALL_TEXT_PX};
    color: #140f4b;
    justify-content: flex-start;
    & span {
        font-family: ${FONT_FAMILY_DEMI};
        margin-left: ${(props) =>
            props.marginLeft ? props.marginLeft : '5px'};
    }

    ${media.mobileDevice`
        flex-direction: column;
        padding: 
        ${(props) =>
            props.filterContainerMobilePadding
                ? props.filterContainerMobilePadding
                : '10px 16px 10px'}; //no padding in template
        border-top-left-radius:${(props) =>
            props.noMobileBorder ? 'unset' : '20px'};
        border-top-right-radius: ${(props) =>
            props.noMobileBorder ? 'unset' : '20px'};
        border-bottom-left-radius:0px;
        border-bottom-right-radius:0px;
        margin:${(props) =>
            props.mobileMargin ? props.mobileMargin : '0 0 -1px 0'};
        box-shadow: none;
        min-height: auto;
        align-items: flex-start;
        background-color: ${({ mobileBackgroundColor }) =>
            mobileBackgroundColor ? mobileBackgroundColor : '#ffffff'};
        width: ${(props) => (props.mobileWidth ? props.mobileWidth : '100%')};
    `}
`;

export const ViewContainer = styled.div`
    // margin: 0 10px;
    flex-basis: 10%;
    display: flex;
    align-items: end;
    & span {
        font-family: ${FONT_FAMILY_DEMI};
        white-space: nowrap;
    }

    ${media.mediumDevice`
        flex-basis: ${(props) =>
            props.flexBasisStyle ? props.flexBasisStyle : '20%'};
    `}
`;

export const FilterDetailsContainerTemplate = styled.div`
    display: flex;
    margin-left: ${(props) => (props.marginLeft ? props.marginLeft : '0px')};

    /* max-width: 100%; */
    width: fit-content;
    overflow: ${(props) => (props.overflow ? props.overflow : 'hidden')};
    white-space: nowrap;
    text-overflow: ellipsis;
    align-content: center;
    align-items: center;
    &::-webkit-scrollbar {
        display: none;
    }
    ${media.smalDevice`
        max-width: 100%;
    `}

    ${media.mobileDevice`
        margin: 0px;
        width: ${({ mobileWidth }) => (mobileWidth ? mobileWidth : '100%')};
        margin-top: ${(props) =>
            props.mobileMargin
                ? 'unset'
                : props.marginTop
                ? props.marginTop
                : '10px'};
    `}
`;

export const FilterDetailsContainer = styled.div`
    display: flex;
    margin: ${(props) =>
        props.containerMargin ? props.containerMargin : '0 5px 0 10px'};
    max-width: 100%;
    overflow: ${(props) => (props.overflow ? props.overflow : 'hidden')};
    white-space: nowrap;
    text-overflow: ellipsis;
    align-items: center;
    &::-webkit-scrollbar {
        display: none;
    }
    margin-top: ${(props) =>
        props.mobileMargin ? 'unset' : props.marginTop ? props.marginTop : '0'};

    ${media.mobileDevice`
        margin: 0px;
        width: ${({ mobileWidth }) => (mobileWidth ? mobileWidth : 'unset')};
        margin-top: ${(props) =>
            props.mobileMargin
                ? 'unset'
                : props.marginTop
                ? props.marginTop
                : '10px'};
    `}
`;

export const ExtraContainer = styled.div`
    font-family: ${FONT_FAMILY_DEMI};
    color: ${TITLE_FONT_COLOR};
    font-size: ${X_SMALL_TEXT_PX}
    align-items: center;
    justify-content: center;
    // line-height: 25px;
    cursor: pointer;
    &::-webkit-scrollbar {
        display: none;
    }
    margin-left: 5px;

    ${media.mobileDevice`
        background-color: transparent;
        border-left: 0;
        border-right: 0;
    `}
`;

export const FilterStringWithPipe = styled.p`
    // display: ${(props) => (props.display ? props.display : '')};
    //           //(in template)
    //display:flex;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: ${(props) => (props.overflow ? props.overflow : 'hidden')};
    flex: 1;
    margin: 0 0 0 5px;
    padding: 0;
    font-family: ${FONT_FAMILY_DEMI};
    font-size: ${SMALL_TEXT_PX};
    // font-size: ${X_SMALL_TEXT_PX};
    text-align: left;
    color: ${DARK_NAVY_FONT_COLOR};
    align-content: center;
    align-items: center;
    width: ${(props) => (props.filtersWidth ? '491px' : 'unset')};

    ${media.mediumDevice`
        width:${(props) => (props.tabFilterWidth ? '450px' : 'unset')};
    `};

    ${media.smalDevice`
        width:${(props) => (props.smallTabWidth ? '430px' : 'unset')};
    `};

    ${media.mobileDevice`
        width:${(props) => (props.mobileWidth ? '182px' : 'unset')};
    `};
`;

export const ClearFilterDesktop = styled.span`
    font-family: ${FONT_FAMILY_DEMI};
    font-size: ${SMALL_TEXT_PX};
    cursor: pointer;
    padding-top: 1px;
    color: ${TITLE_FONT_COLOR};
    display: block;
    text-align: right;
    margin-right: 5px;
    white-space: nowrap;
    ${media.mobileDevice`
        text-align: left;
        margin-left: ${(props) => (props.marginLeftTemplate ? '0rem' : '1rem')};
        margin-bottom: ${(props) =>
            props.marginBottomTemplate ? props.marginBottomTemplate : ''};

    `}
`;

export const ClearFilterMobileTemplate = styled.span`
    display: none;
    ${media.mobileDevice`
        justify-content: center;
        display:flex;
        font-family: ${FONT_FAMILY_DEMI};
        font-size: ${SMALL_TEXT_PX};
        cursor: pointer;
        padding-top: 1px;
        color: ${TITLE_FONT_COLOR};
        min-width: 100px;
        // margin-right: 15px;
    `}
`;

export const ClearFilterMobile = styled.span`
    display: none;
    ${media.mobileDevice`
        display:flex;
        font-family: ${FONT_FAMILY_DEMI};
        font-size: ${SMALL_TEXT_PX};
        cursor: pointer;
        padding-top: 1px;
        color: ${TITLE_FONT_COLOR};
        min-width: 100px;
        margin-right: -6px;
        justify-content: center;
    `}
`;

export const Counter = styled.div`
    height: 21px;
    font-family:  ${FONT_FAMILY_REGULAR};
    background: #ebebeb 0% 0% no-repeat padding-box;
    border-radius: 11px;
    opacity: 1;
    align-items: center;
    text-align: center;
    padding: 0px 1px 2px 1px;
    width: fit-content;
    cursor: pointer;
    margin-top: 2px;
    ${media.mobileDevice`
    border-radius: 11px;
    `}
`;
export const CounterNumber = styled.div`
    font-family: ${FONT_FAMILY_REGULAR};
    font-size: ${X_SMALL_TEXT_PX};
    letter-spacing: -1.1px;
    color: #1010eb;
    width: 26px;
    text-align: center;
    opacity: 1;
`;
